import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import {
  VerifyUser,
  getCounty,
  getDistrict,
  getStates,
  userSignup,
} from "../../api/server";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

import SetupBirthDatePicker from "./SetupBirthDatePicker";
import SetupUserSelect from "./SetupUserSelect";
import "./set-up-user-account.css";

const SetupSectionHeading = ({ number, title, icon }) => (
  <div className="setup-section-heading">
    <span className="setup-section-icon" aria-hidden="true">
      <i className={`fa-solid ${icon}`}></i>
    </span>
    <div>
      <h2 id={`setup-section-${number}`}>{title}</h2>
    </div>
  </div>
);

const SetUpUserAccount = () => {
  const navigate = useNavigate();
  const [showJointFiler, setShowJointFiler] = useState(false);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    middleInitial: Yup.string(),
    lastName: Yup.string().required("Last Name is required"),
    ssn: Yup.string().required("Last Four Digits of SSN is required").matches(/^\d{4}$/, "SSN must be exactly 4 digits"),
    phone: Yup.string().required("Phone Number is required"),
    dob: Yup.string().required("Date of Birth is required"),
    address1: Yup.string().required("Address Line 1 is required"),
    address2: Yup.string(),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    zip: Yup.string().required("Zip Code is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Your Email is required"),
    confirmEmail: Yup.string()
      .oneOf([Yup.ref("email"), null], "Emails must match")
      .required("Confirm Email is required"),
    username: Yup.string().required("Username is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(
        /[A-Z]/,
        "Password must contain at least one uppercase character"
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(
        /[A-Z]/,
        "Password must contain at least one uppercase character"
      ),
    jointFiler_firstName: showJointFiler
      ? Yup.string().required("First name is required")
      : Yup.string(),
    jointFiler_lastName: showJointFiler
      ? Yup.string().required("Last name is required")
      : Yup.string(),
    jointFiler_ssn: showJointFiler ? Yup.string().required("Last Four Digits of SSN is required").matches(/^\d{4}$/, "SSN must be exactly 4 digits"):Yup.string(),
    judicialdistrict_state: Yup.string().required("State is required"),
    judicialdistrict_county: Yup.string().required("County is required"),
    judicialdistrict: Yup.string().required("Judicial District is required"),
    jointFiler_username: showJointFiler
      ? Yup.string().required("Username is required")
      : Yup.string(),
    jointFiler_password: showJointFiler
      ? Yup.string()
          .required("Password is required")
          .min(8, "Password must be at least 8 characters")
          .matches(
            /[A-Z]/,
            "Password must contain at least one uppercase character"
          )
      : Yup.string()
          .min(8, "Password must be at least 8 characters")
          .matches(
            /[A-Z]/,
            "Password must contain at least one uppercase character"
          ),
    // courseTaken: Yup.boolean(),
  });

  const [updateLoading, setUpdateLoading] = useState(false);
  const [statesData, setStatesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCounty, setSelectedCounty] = useState("");
  const [countiesData, setCountiesData] = useState([]);
  const [districtsData, setDistrictsData] = useState([]);
  const [userAttorney, setUserAttorney] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [atternyName, setAtternyName] = useState("");
  const [atternyEmail, setAtternyEmail] = useState("");
  const [atternyNumber, setAtternyNumber] = useState("");
  const [attCodeValidation, setattCodeValidation] = useState(false);

  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [showAttymPass, setShowAttymPass] = useState(false);
  const [noCode, setNoCode] = useState(false);

  //<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< handle Verify Attorney code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  const handleVerifyAttorney = async (e) => {
    setattCodeValidation(false);
    // e.preventDefault();
    const body = {
      code: userAttorney,
    };
    try {
      setLoading(true);
      const response = await VerifyUser(body);
      if (response.status === 200) {
        setReadOnly(true);
        const data = response.data;
        valuesSetter(response?.data?.data);
        setLoading(false);
      } else {
        setattCodeValidation(true);
      }
    } catch (error) {
      setattCodeValidation(true);
      console.error("Error fetching states data:", error);
      setLoading(false);
    }
  };
  //<<<<<<<<<<<<<<<<<<<<  Set Value If Coupon Exist  >>>>>>>>>>>>>>>>>>>>>>>>>>>>
  function valuesSetter(data) {
    setAtternyEmail(data.email);
    setAtternyName(data?.firstname);
    setAtternyNumber(data?.phone);
  }

  const handleSubmit = async (values, { resetForm }) => {
    if (userAttorney && (!atternyNumber || !atternyEmail || !atternyName)) {
      toast.error("Please verify attorney code.");
    } else {
      setUpdateLoading(true);
      let payload = { ...values };
      if (readOnly) {
        payload.attycode = userAttorney;
      }
      payload.attyphone = atternyNumber;
      payload.attyemail = atternyEmail;
      payload.attorneyname = atternyName;
      await userSignup(payload)
        .then((res) => {
          toast.success(`An ${res.data.data.firstname  } account has been created`);
          navigate(`/editstudent?id=${res.data.data.id}`);
          setUpdateLoading(false);
          resetForm();
          setAtternyEmail("");
          setAtternyName("");
          setAtternyNumber("");
          setUserAttorney("");
          setReadOnly(false);
        })
        .catch((error) => {
          setUpdateLoading(false);
          toast.error(error.response.data.error);
          console.error("Error updating user data:", error);
        });
    }
  };

  useEffect(() => {
    const fetchStatesData = async () => {
      try {
        const response = await getStates();
        const data = response.data;
        setStatesData(data);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStatesData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setCountiesData([]);
      try {
        if (selectedState) {
          /////////////////////// get data of county////////////////
          const response = await getCounty({ state: selectedState });
          const countiesData = response.data;
          setCountiesData(countiesData);
        }
      } catch (error) {}
    };

    fetchData();
  }, [selectedState]);

  useEffect(() => {
    const fetchData = async () => {
      setDistrictsData([]);
      try {
        if (selectedCounty) {
          /////////////////////// get data of District////////////////
          const districtResponse = await getDistrict({
            state: selectedState,
            county: selectedCounty,
          });
          const distData = districtResponse.data;

          setDistrictsData(distData);
        }
      } catch (error) {}
    };

    fetchData();
  }, [selectedState, selectedCounty]);

  const handleCheckboxChange = (e) => {
    setShowJointFiler(e.target.checked);
  };

  return (
    <div>
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content" className="setup-user-page">
          <DashboardNavbar />
          <header className="setup-user-heading">
            <div>
              <h1>Set Up User Account</h1>
            </div>
            <span className="setup-user-heading-icon" aria-hidden="true">
              <i className="fa-solid fa-user-plus"></i>
            </span>
          </header>
          <Formik
            initialValues={{
              firstName: "",
              middleInitial: "",
              lastName: "",
              phone: "",
              dob: "",
              ssn: "",
              address1: "",
              address2: "",
              city: "",
              state: "",
              zip: "",
              email: "",
              confirmEmail: "",
              username: "",
              password: "",
              confirmPassword: "",
              jointFiler_firstName: "",
              jointFiler_middleInitial: "",
              jointFiler_lastName: "",
              attyemail: "",
              attycode: "",
              attyphone: "",
              attorneyname: "",
              attypref: "checked",
              // couponCode: "",
              judicialdistrict_state: "",
              judicialdistrict_county: "",
              judicialdistrict: "",
              jointFiler_username: "",
              jointFiler_password: "",
              jointFiler_ssn: "",
              // courseTaken: false,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setValues, errors }) => (
              <Form className="setup-user-form">
                <section className="setup-user-card" aria-labelledby="setup-section-01">
                  <SetupSectionHeading
                    number="01"
                    icon="fa-user"
                    title="Main Filer Information"
                  />
                <div className="row mt-60">
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-firstName">First Name</label>
                      <Field id="setup-firstName"
                        type="text"
                        name="firstName"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-middleInitial">Middle Initial</label>
                      <Field id="setup-middleInitial"
                        type="text"
                        name="middleInitial"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="middleInitial"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-lastName">Last Name</label>
                      <Field id="setup-lastName"
                        type="text"
                        name="lastName"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-ssn">
                        Last Four Digits of SSN
                      </label>
                      <Field id="setup-ssn" type="text" className="form-control" name="ssn" />
                      <ErrorMessage
                        name="ssn"
                        component="div"
                        className="error-message text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-phone">Phone Number</label>
                      <Field id="setup-phone"
                        type="text"
                        name="phone"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-dob">Date of Birth</label>
                      <Field name="dob">
                        {({ field, form }) => (
                          <SetupBirthDatePicker
                            allowTyping
                            dateFormat="yyyy-mm-dd"
                            value={field.value}
                            onChange={(value) => form.setFieldValue(field.name, value)}
                            onBlur={field.onBlur}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="dob"
                        component="div"
                        className="error-message text-danger"
                      />
                    </div>
                  </div>
                </div>
                </section>

                {/* Contact Info */}
                <section className="setup-user-card" aria-labelledby="setup-section-02">
                  <SetupSectionHeading
                    number="02"
                    icon="fa-address-book"
                    title="Contact Information"
                  />
                <div className="row mt-60">
                  <div className="col-lg-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-address1">Address Line 1</label>
                      <Field id="setup-address1"
                        type="text"
                        name="address1"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="address1"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-address2">Address Line 2</label>
                      <Field id="setup-address2"
                        type="text"
                        name="address2"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-city">City</label>
                      <Field id="setup-city" type="text" name="city" className="form-control" />
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-state">State</label>
                      <Field name="state">
                        {({ field }) => (
                          <SetupUserSelect disabled={!statesData.length} id="setup-state"
                            searchable searchPlaceholder="Search states..."
                            {...field}
                            onChange={(e) => {
                              setValues({
                                ...values,
                                state: e.target.value,
                              });
                            }}
                            className="form-control"
                          >
                            {statesData.length > 0 && (
                              <option value="">Select a State</option>
                            )}

                            {statesData.length > 0 ? (
                              statesData.map((state, index) => (
                                <option key={index} value={state.state}>
                                  {state.state}
                                </option>
                              ))
                            ) : (
                              <option value="">Loading...</option>
                            )}
                          </SetupUserSelect>
                        )}
                      </Field>
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-zip">Zip Code</label>
                      <Field id="setup-zip" type="text" name="zip" className="form-control" />
                      <ErrorMessage
                        name="zip"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                </div>
                </section>

                {/* Account Info */}
                <section className="setup-user-card" aria-labelledby="setup-section-03">
                  <SetupSectionHeading
                    number="03"
                    icon="fa-lock"
                    title="Account Information"
                  />
                <div className="row mt-60">
                  <div className="col-lg-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-email">Your Email</label>
                      <Field id="setup-email"
                        type="text"
                        name="email"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-confirmEmail">Confirm Email</label>
                      <Field id="setup-confirmEmail"
                        type="text"
                        name="confirmEmail"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="confirmEmail"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-username">Choose a Username</label>
                      <Field id="setup-username"
                        type="text"
                        name="username"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="username"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-password">Choose a Password</label>
                      <div className="setup-password-control">
<Field id="setup-password"
                        type={showPass ? "text" : "password"}
                        name="password"
                        className="form-control"
                      />
                      <button type="button" className="password-toggle" onClick={() => setShowPass(!showPass)} aria-label={showPass ? "Hide password" : "Show password"} aria-pressed={showPass}><i className={showPass ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i></button>
                      </div>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-confirmPassword">Confirm Password</label>
                      <div className="setup-password-control">
<Field id="setup-confirmPassword"
                        type={showConfirmPass ? "text" : "password"}
                        name="confirmPassword"
                        className="form-control"
                      />
                      <button type="button" className="password-toggle" onClick={() => setShowConfirmPass(!showConfirmPass)} aria-label={showConfirmPass ? "Hide confirmation password" : "Show confirmation password"} aria-pressed={showConfirmPass}><i className={showConfirmPass ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i></button>
                      </div>
                      <ErrorMessage
                        name="confirmPassword"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>
                </div>
                </section>

                <section className="setup-user-card" aria-labelledby="setup-section-04">
                  <SetupSectionHeading
                    number="04"
                    icon="fa-briefcase"
                    title="Attorney & Filing Information"
                  />
                <div className="row mt-40">
                  {!noCode && (
                    <div className="col-lg-4 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title" htmlFor="setup-attycode">
                          Enter Attorney Code
                        </label>
                        <Field id="setup-attycode"
                          type="text"
                          className="form-control"
                          value={userAttorney}
                          onChange={(e) => {
                            setUserAttorney(e?.target?.value);
                            setattCodeValidation(false);
                          }}
                          name="attycode"
                          placeholder="Enter Attorney code"
                        />
                        {attCodeValidation && (
                          <p className="text-danger">Invalid Attorney Code </p>
                        )}
                        {/* <ErrorMessage
                          name="attycode"
                          component="div"
                          className="error-message text-danger"
                        /> */}
                      </div>
                    </div>
                  )}
                  <div className="col-lg-8 col-md-6 setup-attorney-actions">
                    {!noCode && (
                      <button
                        className="btn_brnd-outline mr-22"
                        disabled={loading || !userAttorney.trim()}
                        // disabled={postLoading}
                        type="button"
                        onClick={handleVerifyAttorney}
                      >
                        {loading ? (
                          <ThreeDots
                            height="20"
                            width="52"
                            radius="9"
                            color="#4e9c4b"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "block",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        ) : (
                          "Verify"
                        )}
                      </button>
                    )}
                    <button
                      className="btn_brnd my-3"
                      type="button"
                      onClick={() => {
                        setNoCode(!noCode);
                        setReadOnly(false);
                        setUserAttorney("");
                        setAtternyName("");
                        setAtternyEmail("");
                        setAtternyNumber("");
                      }}
                    >
                      {noCode ? "Add Code" : "No Code ?"}
                    </button>
                  </div>
                </div>
                <div className="row mt-40">
                  <div className="col-lg-4 col-md-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-attyemail">Attorney Email</label>
                      <Field id="setup-attyemail"
                        type="email"
                        className="form-control"
                        name="attyemail"
                        placeholder="Attorney Email"
                        readOnly={!noCode}
                        onChange={(e) => {
                          setAtternyEmail(e.target.value);
                        }}
                        value={atternyEmail}
                      />
                      <ErrorMessage
                        name="attyemail"
                        component="div"
                        className="error-message text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-attorneyname">Attorney Name</label>
                      <Field id="setup-attorneyname"
                        type="text"
                        className="form-control"
                        name="attorneyname"
                        placeholder="Attorney Name"
                        readOnly={!noCode}
                        onChange={(e) => {
                          setAtternyName(e.target.value);
                        }}
                        value={atternyName}
                      />
                      <ErrorMessage
                        name="attorneyname"
                        component="div"
                        className="error-message text-danger"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-attyphone">Attorney Phone</label>
                      <Field id="setup-attyphone"
                        type="text"
                        className="form-control"
                        name="attyphone"
                        placeholder="Attorney Phone"
                        readOnly={!noCode}
                        onChange={(e) => {
                          setAtternyNumber(e.target.value);
                        }}
                        value={atternyNumber}
                      />
                      <ErrorMessage
                        name="attyphone"
                        component="div"
                        className="error-message text-danger"
                      />
                    </div>
                  </div>
                  {/* <div className="col-lg-4 col-md-6">
                      <div className="input_wrap">
                        <label className="label-title">Coupon Code</label>
                        <Field
                          type="text"
                          className="form-control"
                          name="couponCode"
                          placeholder="Enter Coupon Code"
                        />
                        <ErrorMessage
                          name="couponCode"
                          component="div"
                          className="error-message text-danger"
                        />
                      </div>
                    </div> */}
                  <div className="col-lg-4 col-md-6">
                    <div className="input_wrap">
                      <label className="label-title" htmlFor="setup-judicialdistrict_state">Filing State</label>
                      <Field name="judicialdistrict_state">
                        {({ field }) => (
                          <SetupUserSelect disabled={!statesData.length} id="setup-judicialdistrict_state"
                            searchable searchPlaceholder="Search filing states..."
                            {...field}
                            value={selectedState}
                            onChange={(e) => {
                              setSelectedState(e.target.value);
                              setSelectedCounty("");
                              setValues({
                                ...values,
                                judicialdistrict_state: e.target.value,
                                judicialdistrict_county: "",
                                judicialdistrict: "",
                              });
                            }}
                            className="form-control"
                          >
                            {statesData.length > 0 && (
                              <option value="">Select a State</option>
                            )}

                            {statesData.length > 0 ? (
                              statesData.map((state, index) => (
                                <option key={index} value={state.state}>
                                  {state.state}
                                </option>
                              ))
                            ) : (
                              <option value="">Loading...</option>
                            )}
                          </SetupUserSelect>
                        )}
                      </Field>
                      <ErrorMessage
                        name="judicialdistrict_state"
                        component="div"
                        className="error text-danger"
                      />
                    </div>
                  </div>

                  <>
                      {selectedState && (<div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-judicialdistrict_county">Filing County</label>
                          <Field name="judicialdistrict_county">
                            {({ field }) => (
                              <SetupUserSelect disabled={!selectedState || !countiesData.length} id="setup-judicialdistrict_county"
                                searchable searchPlaceholder="Search counties..."
                                {...field}
                                className="form-control"
                                value={selectedCounty}
                                onChange={(e) => {
                                  setSelectedCounty(e.target.value);
                                  setValues({
                                    ...values,
                                    judicialdistrict_county: e.target.value,
                                    judicialdistrict: "",
                                  });
                                }}
                              >
                                {countiesData.length > 0 && (
                                  <option value="">Select a county</option>
                                )}
                                {/* {values.judicialdistrict_county === "" && (
                                <option value="">Select a county</option>
                              )} */}
                                {countiesData.length > 0 ? (
                                  countiesData.map((county, index) => (
                                    <option key={index} value={county.county}>
                                      {county.county}
                                    </option>
                                  ))
                                ) : (
                                  <option value="">{selectedState ? "Loading counties..." : "Select a filing state first"}</option>
                                )}
                              </SetupUserSelect>
                            )}
                          </Field>
                          <ErrorMessage
                            name="judicialdistrict_county"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>)}

                      {selectedCounty && (<div className="col-lg-4 col-md-6">
                          <div className="input_wrap">
                            <label className="label-title" htmlFor="setup-judicialdistrict">
                              Filing District
                            </label>
                            <Field name="judicialdistrict">
                              {({ field }) => (
                                <SetupUserSelect disabled={!selectedCounty || !districtsData.length} id="setup-judicialdistrict" {...field} className="form-control">
                                  {districtsData.length > 0 && (
                                    <option value="">
                                      Select a Judicial District
                                    </option>
                                  )}
                                  {/* {values.judicialdistrict === "" && (
                                <option value="">
                                  Select a Judicial District
                                </option>
                              )} */}
                                  {districtsData.length > 0 ? (
                                    districtsData.map((district, index) => (
                                      <option
                                        key={index}
                                        value={district.subdistrict}
                                      >
                                        { district.subdistrict == "District of Oregon - Portland" ? "I live closer to Portland" :
                                         district.subdistrict == "District of Oregon - Eugene" ? "I live closer to Eugene"
                                         :district.subdistrict
                                        }
                                      </option>

                                    ))
                                  ) : (
                                    <option value="">{selectedCounty ? "Loading districts..." : "Select a filing county first"}</option>
                                  )}
                                </SetupUserSelect>
                              )}
                            </Field>
                            <ErrorMessage
                              name="judicialdistrict"
                              component="div"
                              className="error text-danger"
                            />
                          </div>
                        </div>)}
                    </>
                </div>
                </section>
                {/* <div className="col-12 mb-4" style={{ userSelect: "none" }}>
                  <div className="iagree_radio">
                    <Field
                      name="takenByPhone"
                      id="courseTaken"
                      className=""
                      type="checkbox"
                    />

                    <label htmlFor="courseTaken">
                      Course Taken By Telephone
                    </label>
                  </div>
                </div> */}

                <div className="col-12 mb-4" style={{ userSelect: "none" }}>
                  <div className="iagree_radio">
                    <input
                      type="checkbox"
                      name="isJointFiler"
                      id="joint"
                      onChange={handleCheckboxChange}
                      className=""
                    />

                    <label htmlFor="joint">Add a joint filer</label>
                  </div>
                </div>
                {/* Joint Filer Info */}

                {showJointFiler && (
                  <>
                    <section className="setup-user-card" aria-labelledby="setup-section-05">
                  <SetupSectionHeading
                    number="05"
                    icon="fa-user-group"
                    title="Joint Filer Information"
                  />
                    <div className="row mt-60">
                      <div className="col-lg-4">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-jointFiler_firstName">First Name</label>
                          <Field id="setup-jointFiler_firstName"
                            type="text"
                            name="jointFiler_firstName"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="jointFiler_firstName"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-jointFiler_middleInitial">Middle Initial</label>
                          <Field id="setup-jointFiler_middleInitial"
                            type="text"
                            name="jointFiler_middleInitial"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="jointFiler_middleInitial"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-jointFiler_lastName">Last Name</label>
                          <Field id="setup-jointFiler_lastName"
                            type="text"
                            name="jointFiler_lastName"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="jointFiler_lastName"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-jointFiler_ssn">
                            Last Four Digits of SSN
                          </label>
                          <Field id="setup-jointFiler_ssn"
                            type="text"
                            name="jointFiler_ssn"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="jointFiler_ssn"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-jointFiler_username">
                            Joint Filer's Username
                          </label>
                          <Field id="setup-jointFiler_username"
                            type="text"
                            className="form-control"
                            name="jointFiler_username"
                          />
                          <ErrorMessage
                            name="jointFiler_username"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-jointFiler_password">
                            Joint Filer's Password
                          </label>
                          <div className="setup-password-control">
<Field id="setup-jointFiler_password"
                            type={showAttymPass ? "text" : "password"}
                            className="form-control"
                            name="jointFiler_password"
                          />
                          <button type="button" className="password-toggle" onClick={() => setShowAttymPass(!showAttymPass)} aria-label={showAttymPass ? "Hide joint filer password" : "Show joint filer password"} aria-pressed={showAttymPass}><i className={showAttymPass ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i></button>
                      </div>
                          <ErrorMessage
                            name="jointFiler_password"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                    </div>
                </section>
                  </>
                )}

                <div className="setup-user-actions">
                  <button
                    className="btn_brnd my-3"
                    type="submit"
                    disabled={updateLoading}
                    onClick={() => {
                      if (Object.keys(errors).length > 0) {
                        toast.error("Form validation failed");
                      }
                    }}
                  >
                    {updateLoading ? (
                      <ThreeDots
                        height="20"
                        width="60"
                        radius="9"
                        color="#4fa94d"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{
                          display: "block",
                        }}
                        wrapperClassName="spinner"
                        visible={true}
                      />
                    ) : (
                      "Create"
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default SetUpUserAccount;
